import { render, staticRenderFns } from "./OnlineCoverageBanner.vue?vue&type=template&id=33b9585e"
import script from "./OnlineCoverageBanner.vue?vue&type=script&lang=js"
export * from "./OnlineCoverageBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports